import { useLocalStorage } from 'react-use'
import { UsernameData } from '../types'

export function useRecents(limit: number): [UsernameData[], (data: UsernameData) => void] {
    const [recents = [], setRecents] = useLocalStorage<UsernameData[]>('username-field-recents')

    function addRecent(data: UsernameData) {
        setRecents((state = []) => {
            const index = state.findIndex(({ username }) => username === data.username)

            if (index < 0) {
                return [data, ...state].slice(0, limit)
            }

            return state.map((recent) => {
                if (recent.username === data.username) {
                    return data
                }

                return recent
            })
        })
    }

    return [recents, addRecent]
}
